<template>
  <div class="nauta-announce">
    <div class="nauta-announce-left-content">
      <div class="nauta-announce-logos">
        <img
          src="@/assets/migration/nauta-migration-logos.png"
          alt="Nauta Logos"
        />
      </div>
      <div
        class="nauta-announce-text-container"
        @click="$router.push({ name: 'nautaMigration' })"
      >
        <div class="nauta-announce-title">
          {{ $t("nautaAnnounce.title") }}
        </div>
        <div class="nauta-announce-text">
          <span>
            {{ $t("nautaAnnounce.text") }}
          </span>
          <a>{{ $t("nautaAnnounce.learnMore") }}
            <v-icon color="#C1B1FF" size="15"> mdi-arrow-right </v-icon>
          </a>
        </div>
      </div>
    </div>
    <div class="nauta-announce-download-button">
      <NewButton
        :text="$t('nautaAnnounce.downloadNauta')"
        @on-click="displayNautaDownloadModal = true"
      />
    </div>
    <NautaDownloadModal
      id="download-modal"
      :value="displayNautaDownloadModal"
      @display="displayNautaDownloadModal = $event"
    />
  </div>
</template>

<script>
import NewButton from "@/components/shared/NewButton.vue";
import NautaDownloadModal from "../migration/NautaDownloadModal.vue";

export default {
  name: "AnnounceBar",

  data() {
    return {
      displayNautaDownloadModal: false,
    };
  },

  components: { NewButton, NautaDownloadModal },
};
</script>

<style lang="scss" scoped>
.nauta-announce {
  background-color: #000;
  padding: 40px;
  margin: 40px 0;

  border-radius: 10px;

  display: flex;
  align-items: center;
  gap: 0 40px;

  @media (max-width: 1264px) {
    margin: 20px 20px 0 20px !important;
  }

  @media (max-width: 600px) {
    display: block;
    padding: 24px 20px;
  }
}

.nauta-announce-left-content {
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: 24px;

  @media (max-width: 600px) {
    flex-direction: row-reverse;
  }
}

.nauta-announce-logos img {
  width: auto;
  max-width: 110px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 600px) {
    max-width: 80px !important;
  }
}

.nauta-announce-text-container {
  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
    gap: 8px 0;
  }
}
.nauta-announce-title {
  color: #fff;
  font-family: "Work Sans";
  font-size: 22px;
  font-weight: 600;
  line-height: 140%;
  letter-spacing: -0.52px;

  @media (max-width: 600px) {
    font-size: 18px;
  }
}

.nauta-announce-text {
  color: #bdbdbd;
  font-size: 14px;
  font-weight: 500;
  line-height: 140%;

  @media (max-width: 600px) {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  a {
    font-weight: 600 !important;
    color: #c1b1ff !important;
    text-decoration: none;
  }
}

.nauta-announce-download-button {
  min-width: 220px;

  @media (max-width: 600px) {
    margin-top: 20px;
  }
}

.nauta-announce-download-button ::v-deep .new-btn {
  background-color: #9378ff !important;
}
</style>
